
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IGroupOption } from "@tylertech/tyler-api-types";

/**
 * SegmentService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class SegmentService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetSubSegmentValues(id: string): Promise<IGroupOption[]> {
        return this.$apiService.sendAuth("ISegmentService/GetSubSegmentValues", id);
    }
}
